export default "__VITE_ASSET__1f98262a__"